import { Component } from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {UserSelfService} from '../../core/services/self-service/user-self.service';
import {ButtonComponent} from '../../shared/components/button/button.component';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [
    RouterLink,
    ReactiveFormsModule,
    TranslateModule,
    CommonModule,
    ButtonComponent
  ],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent {
  resetPasswordForm!: FormGroup;
  isLoading = false;
  errorMessage = '';
  successMessage = '';
  resetComplete = false;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly userSelfService: UserSelfService,
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const email = params['email'];
      this.initForm(email);
    });
  }

  initForm(email: string = ''): void {
    this.resetPasswordForm = this.formBuilder.group({
      email: [{value: email, disabled: !!email}, [Validators.required, Validators.email]],
      code: ['', [Validators.required, Validators.pattern(/^\d{8}$/)]],
      password: ['', [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(32),
        Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).+$/)
      ]],
      confirmPassword: ['', Validators.required]
    }, { validators: this.passwordMatchValidator });
  }

  passwordMatchValidator(form: FormGroup) {
    const password = form.get('password')?.value;
    const confirmPassword = form.get('confirmPassword')?.value;

    if (password !== confirmPassword) {
      form.get('confirmPassword')?.setErrors({ passwordMismatch: true });
      return { passwordMismatch: true };
    }

    return null;
  }

  onSubmit(): void {
    if (this.resetPasswordForm.invalid) {
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';
    this.successMessage = '';

    // Get the raw form values including disabled controls
    const formValues = this.resetPasswordForm.getRawValue();
    const { email, code, password, confirmPassword } = formValues;

    this.userSelfService.resetPassword(email, code, password, confirmPassword).subscribe({
      next: () => {
        this.isLoading = false;
        this.resetComplete = true;
        this.successMessage = 'PASSWORD.RESET_SUCCESS';
      },
      error: (error) => {
        this.isLoading = false;
        this.errorMessage = error.message;
      }
    });
  }

  goToLogin(): void {
    this.router.navigate(['/login']);
  }
}
